import axios from "axios";
import { FormTemplateTypeEnum } from "../_common/enum/forms/fomTemplateType.enum";
import { FormStatusEnum } from "../_common/enum/forms/formStatus.enum";
import { IFormTemplateManage } from "../_common/models/formTemplate";
import { API_URL } from "../_config/config.const";
import { getBody } from "../_helpers/body.helper";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader, getUploadHeader } from "../_helpers/header.helper";
import { getQuery } from "../_helpers/query.helper";

const API_NAME = "formTemplate";

export const formTemplateService = {
    get,
    getAll,
    getAllByType,
    post,
    put,
    disable,
    submitForm,
    duplicateForm,
   // submit(model?: FormData) { return model?.id ? put(model) : post(model) }
};

function get(id: number) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/get/?id=${id}`, requestOptions).then(handleResponse);
}

function getAllByType(formTemplateTypeId?: FormTemplateTypeEnum, formStatusId?: FormStatusEnum) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/getAllByType/?formTemplateTypeId=${formTemplateTypeId}&formStatusId=${formStatusId}`, requestOptions).then(handleResponse);
}

function getAll(query?: any) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/getAll/?${getQuery(query)}`, requestOptions).then(handleResponse);
}

function post(model?: FormData) {
    const config = {
        headers: getUploadHeader()
    }

    return axios.post(`${API_URL}/${API_NAME}/`, model, config);
}

function put(model?: FormData) {
    const config = {
        headers: getUploadHeader()
    }

    return axios.put(`${API_URL}/${API_NAME}/`, model, config);
}

function submitForm(formTemplateId: number) {
    const requestOptions = { method: 'POST', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/submitForm?formTemplateId=${formTemplateId}`, requestOptions).then(handleResponse);
}

function duplicateForm(formTemplateId: number) {
    const requestOptions = { method: 'POST', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/duplicateForm?formTemplateId=${formTemplateId}`, requestOptions).then(handleResponse);
}




function disable(id: number) {
    const requestOptions = { method: 'DELETE', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/${id}`, requestOptions).then(handleResponse);
}